import moment from 'moment'
import React from 'react'
import Form from 'react-bootstrap/Form'
import I18n from 'resources/i18n/I18n'
import './status.scss'

const CommentChat = ({ statuses, event, newComment, onCommentChange, readOnly }) => {
  const newStatus = statuses.find((s) => s.status === 'NEW')
  const initComment =
    event?.comment && event.comment.trim().length > 0
      ? [{ id: 'init', author: newStatus?.idUser || '', date: newStatus?.date || null, text: event.comment }]
      : []

  const statusComments = statuses
    .filter((s) => s.id !== -1 && s.comment && s.comment.trim().length > 0)
    .map((s) => ({
      id: s.id,
      author: s.idUser || '',
      date: s.date,
      text: s.comment,
    }))

  const comments = [...initComment, ...statusComments]

  return (
    <div className="comment-chat">
      <span className="subtitle">{I18n.t('CommentHistory')}</span>

      <div className="comment-list mt-2">
        {comments.length === 0 && <p className="no-comments">{I18n.t('NoComments')}</p>}
        {comments.map((c) => (
          <div key={c.id} className="comment-bubble">
            <div>
              <span className="comment-author">{c.author}</span>
              {c.date && <span className="comment-date">{moment(c.date).format('DD/MM/YYYY à HH:mm')}</span>}
            </div>
            <div className="comment-text">{c.text}</div>
          </div>
        ))}
      </div>

      {!readOnly && (
        <div className="comment-input mt-2">
          <Form.Group>
            <Form.Label>{I18n.t('AddComment')}</Form.Label>
            <Form.Control
              as="textarea"
              rows="3"
              placeholder={I18n.t('CommentPlaceholder')}
              value={newComment}
              onChange={(e) => onCommentChange(e.target.value)}
            />
          </Form.Group>
        </div>
      )}
    </div>
  )
}

export default CommentChat
